/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.broadcast.syndication";

export { $nsid };

/** Record created by a Streamplace broadcaster to indicate that they will be replicating a livestream. NYI */
type Main = { $type: "place.stream.broadcast.syndication";

  /**
   * DID of the Streamplace broadcaster that will be replicating the livestream
   */
  "broadcaster":l.DidString;

  /**
   * DID of the streamer whose livestream is being replicated
   */
  "streamer":l.DidString;

  /**
   * Client-declared timestamp when this syndication was created.
   */
  "createdAt":l.DatetimeString };

export type { Main };

/** Record created by a Streamplace broadcaster to indicate that they will be replicating a livestream. NYI */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"broadcaster":/*#__PURE__*/ l.string({"format":"did"}),"streamer":/*#__PURE__*/ l.string({"format":"did"}),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
